import { render } from "./SSLink.vue?vue&type=template&id=422dd3e5"
import script from "./SSLink.vue?vue&type=script&lang=js"
export * from "./SSLink.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__